module.exports = __webpack_public_path__ + "img/qualita.5207c128.svg";